<template>
    <div class="row">
        <div class="col-6 offset-3">
            <b-card header="¿Necesitas Ayuda?" class="mt-5">
                <div class="alert alert-primary">
                    <p>Hola legionario, primero que nada queremos agradecerte por ser parte de esta gran comunidad.</p>
                    <p>Si necesitas ayuda con la app por favor envianos un correo a <a
                            href="mailto:contacto.legionanime@gmail.com">contacto.legionanime@gmail.com</a> y escribenos
                        como te podemos ayudar a resolver tus conflictos o sugerencias.</p>
                </div>
            </b-card>
            <b-card-group deck :class="'mt-5'" style="display: none;">
                <b-card
                        header="Formulario de Ayuda"
                        header-tag="header"
                        footer-tag="footer">
                    <b-form @submit.prevent="onSubmit">
                        <b-form-group id="input-group-3" label="Asunto:" label-for="input-3">
                            <b-form-select
                                    id="input-3"
                                    v-model="subject"
                                    :options="subjects"
                                    required
                            ></b-form-select>
                        </b-form-group>

                        <b-form-group id="input-group-3" label="Descripción:" label-for="input-3">
                            <b-form-textarea
                                    id="textarea"
                                    v-model="body"
                                    placeholder=""
                                    rows="3"
                                    max-rows="6"
                            ></b-form-textarea>
                        </b-form-group>
                        <b-form-group>
                            <input type="submit" class="btn btn-success btn-block mt-3" value="Enviar">
                        </b-form-group>
                    </b-form>
                </b-card>

            </b-card-group>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Support",
        data() {
            return {
                subjects: ['Conflicto', 'Sugerencia'],
                subject: '',
                body: '',
            }
        },
    }
</script>

<style scoped>

</style>
